import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class CerealVolcadora {
  static getCerealAsignadoVolcadoras () {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_volcadora_cereal_asignado`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static getCerealVolcadorasOriginal () {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_volcadora_cereal_original`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }
}

export default CerealVolcadora
